export default __webpack_public_path__ + "images/DT.e7aeb29.png";